<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="center"><img alt="" src="OEBPS/images/9780312602765_L03.png"/></p>
<p class="center2"><span class="small"><strong>SQUARE</strong></span></p>
<p class="center3"><span class="small"><strong>FISH</strong></span></p>
<p class="center">An Imprint of Macmillan</p>
<p class="center"><span class="small">SIDE EFFECTS</span>. Copyright © 2006 by Amy Goldman Koss. All rights reserved.<br/>Distributed in Canada by H.B. Fenn and Company Ltd. Printed in March 2010<br/>in the United States of America by R. R. Donnelley &amp; Sons Company,<br/>Harrisonburg, Virginia. For information, address Square Fish,<br/>175 Fifth Avenue, New York, NY 10010.</p>
<p class="center">Square Fish and the Square Fish logo are trademarks of Macmillan and are used by Roaring Brook Press under license from Macmillan.</p>
<p class="center">Library of Congress Cataloging-in-Publication Data<br/>Koss, Amy Goldman<br/>Side effects / Amy Goldman Koss.<br/>p. cm.<br/>“A Deborah Brodie Book.”<br/>Summary: Everything changes for Isabelle, not quite fifteen,<br/>when she is diagnosed with lymphoma—but eventually she<br/>survives and even thrives.<br/>ISBN: 978-0-312-60276-5<br/>[1. Cancer—Fiction. 2. Chemotherapy—Fiction.<br/>3. Family problems—Fiction.] I. Title.<br/>PZ7.K8527Sid    2006    [Fic]—dc22<br/>2005     031473</p>
<p class="center">Originally published in the United States by Deborah Brodie Books,<br/>an imprint of Roaring Brook Press<br/>Square Fish logo designed by Filomena Tuosto<br/>Book design by Robin Hoffman / Brand X Studios<br/>First Square Fish Edition: 2010<br/>10  9  8  7  6  5  4  3  2  1<br/><a class="hlink" href="http://www.squarefishbooks.com" target="_blank">www.squarefishbooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312602765_epub_cop_r1.vue?e74e7bf0